export const BREAK_WIDTHS = {
  mediumMobile: 414,
  largeMobile: 576,
  tablet: 769,
  desktop: 992,
  largeDesktop: 1200,
  extraLargeDesktop: 1600,
};

export const BADGE_COLORS = {
  success: {
    fontColor: "rgb(43, 115, 54)",
    backgroundColor: "rgb(235, 244, 236)",
    borderColor: "rgb(215, 234, 217)",
  },
  neutral: {
    fontColor: "rgb(87, 87, 86);",
    backgroundColor: "rgb(245, 247, 249);",
    borderColor: "rgb(232, 237, 241);",
  },
};
